import { ArticleTypeCode } from '@/types/article'
import { Platform } from '@/types/platform'

interface Params {
  articleTypeCode: ArticleTypeCode
  articleId: number
  platform: Platform
}

export function getArticleLocation({
  articleId,
  articleTypeCode,
  platform,
}: Params) {
  const isTopic = articleTypeCode === ArticleTypeCode.TOPIC

  if (isTopic) {
    return {
      name: 'discussion_topic_edit',
      params: {
        id: articleId,
        platform,
      },
    }
  }

  return {
    name: 'content_article',
    params: {
      id: articleId,
      platform,
    },
  }
}
